// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"dd8bbde5","675":"5ccfa965","954":"985e8cab"}[chunkId] + ".chunk.css";
};